import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { defaultConfig } from "../config";  

const firebaseConfig = {
  apiKey: defaultConfig.firebase.apiKey,
  authDomain: defaultConfig.firebase.authDomain,
  projectId: defaultConfig.firebase.projectId,
  storageBucket: defaultConfig.firebase.storageBucket,
  messagingSenderId: defaultConfig.firebase.messagingSenderId,
  appId: defaultConfig.firebase.appId,
};

const isConfigured = Object.values(firebaseConfig).every(Boolean);

if (!isConfigured) {
  console.warn("Firebase config is incomplete - push notifications disabled.");
}

export const app = isConfigured ? initializeApp(firebaseConfig) : null;

export const getFirebaseMessaging = async () => {
  if (!app) return null;
  try {
    const supported = await isSupported();
    return supported ? getMessaging(app) : null;
  } catch (error) {
    console.warn("Firebase messaging unavailable:", error);
    return null;
  }
};

export const FIREBASE_VAPID_KEY = defaultConfig.firebase.vapidKey;
export const APP_VERSION = defaultConfig.firebase.appVersion;